export default __webpack_public_path__ + "static/media/title_en_sp.fa4d2955.png";